import { KOGTableRow } from '@/main/components/shared/kogBoxGrid/styles';
import StatusComponent from '@/main/components/shared/status/statusComponent';
import { TextEllipsis } from '@/main/components/shared/styles';
import { ApprovalMatrixSearchResponse } from '@/main/models/response';
import { RoutesConstants } from '@/main/routes/routesConstants';
import { getTranslateByKey } from '@/main/services/utils';
import { Search } from '@mui/icons-material';
import { IconButton, TableCell } from '@mui/material';
import { useNavigate } from 'react-router-dom';

interface IRowApprovalMatrix {
  item: ApprovalMatrixSearchResponse;
  index: number;
}

export default function RowApprovalMatrix({
  item,
  index
}: Readonly<IRowApprovalMatrix>) {
  const navigate = useNavigate();
  const handleEdit = (guid: string) => {
    navigate(
      `${RoutesConstants.registrationRegisterApprovalMatrix}?guid=${guid}`
    );
  };
  return (
    <KOGTableRow
      $isSizeLong
      onClick={() => handleEdit(item.approvalMatrixGuid)}
      id={`id-searchApprovalMatrix-row-${index}`}>
      <TableCell>
        <TextEllipsis title={item.insurerName}>{item.insurerName}</TextEllipsis>
      </TableCell>
      <TableCell>
        <TextEllipsis title={item.approvalMatrixName}>
          {item.approvalMatrixName}
        </TextEllipsis>
      </TableCell>

      <TableCell>
        <TextEllipsis title={item.approvalMatrixTypeName}>
          {item.approvalMatrixTypeName}
        </TextEllipsis>
      </TableCell>
      <TableCell>
        <TextEllipsis title={item.approvalMatrixStatusName}>
          <StatusComponent
            status={{
              idStatusRegister: item.idStatusRegister,
              name: item.approvalMatrixStatusName
            }}
          />
        </TextEllipsis>
      </TableCell>
    </KOGTableRow>
  );
}
